import React, { useState } from "react";
import { Tag } from "rsuite";
import BasicPanel from "../../components/panels/basicPanel/basicPanel";
import "./packageTracking.css"
import { useLanguage } from "../../context/localeContext";
import { useTranslation } from "react-i18next";
import { useMessenger } from "../../context/messengerContext";
import { buildUserIdPayload } from "../../utils/userIdPayload";

const ARROW_SVG = 
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8333 8.125L17 12.5M17 12.5L12.8333 16.875M17 12.5L7 12.5" stroke="#B4B4B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>




const LabelWithSubLabel = ({ label, subLabel }) => {
    return (
        <div className={`labelWithSubLabel`}>
            <div className="paragraph-12R" style={{color: "var(--Gray-700)"}}>{label}</div>
            <div className="paragraph-12R">{subLabel}</div>
        </div>
    )
  }
  
  const LabelWithValueAndKey = ({ label, subLabel, value }) => {
    return (
        <div className={`labelWithValueAndKey`}>
            <LabelWithSubLabel label={label} subLabel={subLabel} />
            <div className="paragraph-12R labelValue" style={{color: "var(--Gray-900)"}}>{value}</div>
        </div>
    )
  }

export default function TrackItem ({track_data}) {
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [loadingBarcode, setLoadingBarcode] = useState(false);

    const { t } = useTranslation('basic');
    const { userId, platform } = useMessenger();
    console.log(track_data)

    const sendWaybill = async () => {
        try {
          setLoadingPDF(true);
          await fetch("/api/tracking/send/waybill", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ track_number: track_data.track_number, contract_number: track_data.contract_number, ...buildUserIdPayload(platform, userId) }),
          });
        } catch (err) {
          console.error("Ошибка при отправке PDF:", err);
        } finally {
          setLoadingPDF(false);
        }
      };

      const sendBarcode = async () => {
        try {
          setLoadingBarcode(true);
          await fetch("/api/tracking/send/barcode", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ track_number: track_data.track_number, contract_number: track_data.contract_number, ...buildUserIdPayload(platform, userId) }),
          });
        } catch (err) {
          console.error("Ошибка при отправке штрих-кода:", err);
        } finally {
          setLoadingBarcode(false);
        }
      };
    
    return (
        <BasicPanel>
            <div className={"trackItemInfo"}>
                <div className="packageInfoHeader">
                    <div className="packageInfoHeaderLeft">
                        <div className="paragraph-14M">{t("track_number_prefix")}{track_data.track_number}</div>
                        <div className="paragraph-10R">{t("contract_word")} {track_data.contract_number}</div>
                    </div>
                    <div className="packageInfoHeaderRight">
                        <Tag style={{color: "var(--primary)"}}>{track_data.name}</Tag>
                    </div>
                </div>


                <div className="trackItemButtons">
                    <button
                        className="track-btn"
                        onClick={sendWaybill}
                        disabled={loadingPDF}
                    >
                        {loadingPDF ? t("sending_progress") : "PDF"}
                    </button>
                    <button
                        className="track-btn"
                        onClick={sendBarcode}
                        disabled={loadingBarcode}
                    >
                        {loadingBarcode ? t("sending_progress") : t("barcode_button")}
                    </button>
                </div>

                <LabelWithValueAndKey label={t("current_location")} value={track_data.current_city} />
                <LabelWithValueAndKey
                    label={t("planned_delivery_date")}
                    value={track_data.planned_delivery_date?.split(" ")[0] || "—"} 
                    />
                <div className="trackItemCities">
                    <div className="trackItemCity paragraph-14R">
                        <span>{track_data.from_location}</span>
                        {track_data.company_name_sender ?
                            <span className="paragraph-12R" style={{color: "var(--Gray-800)"}}>{track_data.company_name_sender}</span>
                            :
                            null
                        }
                    </div>
                    <span className="aligned" style={{
                        width: "1.5rem",
                        height: "1.5rem",
                    }}>
                        {
                            ARROW_SVG
                        }
                    </span>
                    <div className="trackItemCity paragraph-14R">
                    <span>{track_data.to_location}</span>
                        {track_data.company_name_recipient ?
                            <span className="paragraph-12R" style={{color: "var(--Gray-800)"}}>{track_data.company_name_recipient}</span>
                            :
                            null
                        }
                    </div>
                </div>
            </div>
        </BasicPanel>
    )
}